export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2589c1b3&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/faq/category/index.vue?vue&type=template&id=2589c1b3&
// module id = 1365
// module chunks = 0